// WhatsAppMessage.js
import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { Modal } from 'bootstrap';

import { FileUpload, Input, Radio, Datepicker, TextArea, WhatsappEditor, PhoneInput } from "../../components/input";
import { parsePhoneNumber } from 'react-phone-number-input';
import { SecondaryBtn, PrimaryBtn, TextBtn, Toggle } from "../../components/cta/index";
import LoaderImg from "../../assets/images/loader/mintd-loader.gif";
import Delete from "../../assets/images/modal/delete.svg";
import { Editor } from "../../components/input/index";
import { NotificationConfirm, ViewTemplateInstructions } from '../../components/modal';
import SelectBox from '../../components/dropdown/selectBox';
import { Toast } from '../../components/note';
import { DataTable } from '../../components/dataFormating';

import APIPost from "../../services/postApi";
import devconfig from "../../config/config";
import APIGet from '../../services/getApi';
import { WEBINAR_CONTENT_COUNT, WEBINAR_CONTENT_KEYS, WEBINAR_URL_PREFIX, isWebinarTemplate, cleanWebinarSuffix, buildWebinarUrl, isValidWebinarSuffix, getWebinarContentsFromData, getWebinarUrlFromData } from '../../config/webinarTemplate';
import FallbackImage from '../../components/notification/fallbackImage';
import moment from 'moment';

import style from '../../styles/components/searchInput.module.scss';
import { message } from 'antd';

const WHATSAPP_TEMPLATES = {
    signup_incomplete: `
<h5>👋 Let’s Get You Invested! ☺️</p><p>You started setting up your investment account with us on <b>[Start Date]</b>, and we’d love to help you finish!</p><p>Maybe you got busy or had questions? No worries! Completing your account lets you: <p/><ul><li> Grow your wealth with expert guidance</li><li> Achieve financial goals like retirement or career break</li><li> Enjoy tax benefits and smart investing strategies</li></ul>
`,

    signup_account_created: `
<h5>👋 Next Step: Start Investing! ☺️</h5><p>Hi <b>[Client Name]</b>,</p><p>Congrats on setting up your investment account with us on <b>[Date]</b>!</p><p>You’re one step away from growing your wealth. Now’s the time to start investing and work towards your financial goals.</p><p>Need help choosing the right investment options or have questions? </p><p>Let’s get your money working for you!</p>
`,

    elapsed_since_account_created: `
<h5>⌛ Time to Get Started! ☺️</h5><p>Hi <b>[Client Name]</b>,</p><p>You’re all set up with us 🎉, and now it’s time to put your money to work! 🌟</p><p>You created your account <b id="days-placeholder"><span>[days]</span></b> days ago – let’s get investing and grow your wealth 💰. Need help choosing the right options? We’re here! 📈</p>
`,

    elapsed_since_last_investment: `
<h5>👋 How’s Your Portfolio Doing?  ☺️</h5><p>Hi <b>[Client Name]</b>,</p><p>It’s been <b id="days-placeholder"><span>[days]</span></b> days since your last investment! ⭐  We’re excited to help you grow your wealth, but we haven’t seen any new investments from you recently.</p><p>Need help reviewing your portfolio or exploring new opportunities? 📈 Let’s connect and make your money work harder for you! </p>
`,

    rebalance_pending: `
<h5>👋 Final Step: Complete Your Rebalance! ☺️</h5><p>Hi <b>[Client Name]</b>,</p><p>Your portfolio rebalancing order is pending approval for amount <b><amount></b> ! 📈 Let’s get it done and keep your investments on track towards your goals 💰.</p><p>Need help reviewing the changes or have questions? We’re here! 🚀</p><p>Approve now: <b>[Approval Link]</b></p>
`,
    general_template: `
Hi <b>[Client Name]</b>, 

[content one]

[content two]
`
};

const NORMALIZED_SIP_DATES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];

const TIME_SLOT = [
    { value: '08:00:00AM', label: '08:00 AM' },
    { value: '09:00:00AM', label: '09:00 AM' },
    { value: '10:00:00AM', label: '10:00 AM' },
    { value: '11:00:00AM', label: '11:00 AM' },
    { value: '12:00:00PM', label: '12:00 PM' },
    { value: '01:00:00PM', label: '01:00 PM' },
    { value: '02:00:00PM', label: '02:00 PM' },
    { value: '03:00:00PM', label: '03:00 PM' },
    { value: '04:00:00PM', label: '04:00 PM' },
    { value: '05:00:00PM', label: '05:00 PM' },
    { value: '06:00:00PM', label: '06:00 PM' },
    { value: '07:00:00PM', label: '07:00 PM' },
];

// Local storage key used for draft saving
const LS_KEY = "whatsapp_notification_data";

const STORED_DATA_WHATSAPP = {
    message: "",
    message1: "",
    attachmentType: 1,
    imageAttachments: [{ image: "" }],
    videoAttachments: [{ video: "" }],
    docAttachments: null,
    userUrl: "",
    csvName: "",
    type: 1, // target: all/upload/select
    segment: null,
    signup: null,
    rebalance: null,
    repeat_day: null,
    send_later: false,
    start_date: null,
    end_date: null,
    time: null,
    frequency: null,
    week_day: null,
    month_day: null,
    users: [],
    custom_phones: [""],
    is_one_time: false,
    webinar_url: "",
    webinar_contents: Array(WEBINAR_CONTENT_COUNT).fill(""),
};

const WhatsAppMessage = (props) => {
    const searchRef = useRef(null);

    const [selectedTemplate, setSelectedTemplate] = useState("");
    // ---------------- STATE ----------------
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const [message, setMessage] = useState("");
    const [message1, setMessage1] = useState("");
    const [attachments, setAttachments] = useState([{ image: "" }]);
    const [uploadingIndex, setUploadingIndex] = useState(-1);
    const [type, setType] = useState(1);
    const [openPopup, setOpenPopup] = useState(false);
    const [csvLoader, setCsvLoader] = useState(false);

    const [userUrl, setUserUrl] = useState("");
    const [csvName, setCsvName] = useState("");
    const [generalFilters, setGeneralFilters] = useState([]);
    const [sendLater, setSendLater] = useState(false);
    const [selectedSegment, setSelectedSegment] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [addedTime, setAddedTime] = useState(null);
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [selectedSignUpStatus, setSelectedSignUpStatus] = useState(null);
    const [selectedRebalanceStatus, setSelectedRebalanceStatus] = useState(null);
    const [selectedRepeatDay, setSelectedRepeatDay] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [repeatedDate, setRepeatedDate] = useState(null);
    const [selectedRepeatedDate, setSelectedRepeatedDate] = useState(null);
    const [selectedWeekDay, setSelectedWeekDay] = useState(null);
    const [loader, setLoader] = useState(false);
    const [sendAgain, setSendAgain] = useState(false);
    const [notificationUsers, setNotificationUsers] = useState([]);
    const [notificationListLoader, setNotificationListLoader] = useState(false);
    const [attachmentType, setAttachmentType] = useState(1);
    const [imageAttachments, setImageAttachments] = useState([{ image: "" }]);
    const [videoAttachments, setVideoAttachments] = useState([{ video: "" }]);
    const [docAttachments, setDocAttachments] = useState(null);
    const [docAttachLoader, setDocAttachLoader] = useState(false);
    const [openUsersList, setOpenUsersList] = useState(false);
    const [isOneTime, setIsOneTime] = useState(false);
    const [selectedTemplateType, setSelectedTemplateType] = useState(null);
    const [customPhones, setCustomPhones] = useState([""]);
    // webinar_invite template: header image flows through the existing
    // imageAttachments state; the registration url (suffix only — the fixed
    // WEBINAR_URL_PREFIX is prepended when building the final url) +
    // content_one..content_seven are collected here. body_1 (recipient name)
    // is auto-populated by backend.
    const [webinarUrlSuffix, setWebinarUrlSuffix] = useState("");
    const [webinarContents, setWebinarContents] = useState(Array(WEBINAR_CONTENT_COUNT).fill(""));
    // File input refs
    const fileRefs = useRef({});

    // Stored draft state
    const [storedData, setStoredData] = useState(STORED_DATA_WHATSAPP);

    // webinar_invite is selected when the chosen template name matches.
    // It is a manual template (target: all/upload/custom) and never a segment
    // auto-template, so it is inactive when target audience is "Select segment".
    const webinarTemplate = isWebinarTemplate(selectedTemplateType) && type !== 3;
    // TEMP DEBUG: remove before commit
    console.log('[webinar] gate ->', { selectedTemplate: selectedTemplateType, value: selectedTemplateType?.value, label: selectedTemplateType?.label, type, webinarTemplate });
    // Webinar requires the header image + a valid registration url suffix + all 7 contents.
    const webinarReady = imageAttachments.some(item => item.image && item.image !== "")
        && isValidWebinarSuffix(webinarUrlSuffix)
        && webinarContents.every(value => (value || "").trim() !== "");

    const TABLE_COLUMN = [
        {
            name: 'User name',
            selector: row => row.customer_name,
            sortable: false,
            left: true,
            minWidth: '150px',
            cell: row => row.customer_name
        },
        {
            name: 'Mobile',
            selector: row => row.customer_phone,
            sortable: false,
            left: true,
            minWidth: '200px',
            cell: row => <span>{row.customer_phone ? row.customer_phone : '-'}</span>
        },
        {
            name: 'Email',
            selector: row => row.customer_name,
            sortable: false,
            left: true,
            minWidth: '200px',
            cell: row => <span>{row.customer_email ? row.customer_email : '-'}</span>
        },
    ]

    // ---------------- Helpers for localStorage ----------------
    // Supports either (_updateStore(key, value)) or (_updateStore(null, {a:1, b:2}))
    const _updateStore = (key, value) => {
        setStoredData(prev => {
            const updated = key ? { ...prev, [key]: value } : { ...prev, ...value };
            try {
                localStorage.setItem(LS_KEY, JSON.stringify(updated));
            } catch (e) {
                // ignore storage errors
                console.warn("Failed to write draft to localStorage", e);
            }
            return updated;
        });
    };

    const applyDynamicNumbers = (template) => {

        if (!template) return template;

        const wrapper = document.createElement("div");
        wrapper.innerHTML = template;

        const el = wrapper.querySelector("#days-placeholder");
        console.log('el', el);
        if (el) {
            if (selectedRepeatDay && selectedRepeatDay !== "") {
                el.innerText = selectedRepeatDay;
            } else {
                el.innerText = "[days]";
            }
            console.log('selectedRepeatDay', selectedRepeatDay);
        }

        return wrapper.innerHTML;
    };

    const buildGeneralTemplate = (message, message1) => {
        let template = WHATSAPP_TEMPLATES.general_template;

        template = template.replace("{{1}}", message || "");
        template = template.replace("{{2}}", message1 || "");

        return template;
    };




    const _clearStore = () => {
        try {
            localStorage.removeItem(LS_KEY);
        } catch (e) {
            console.warn("Failed to clear draft store", e);
        }
        setStoredData(STORED_DATA_WHATSAPP);
    };

    // ---------------- Effects ----------------



    // When component mounts, set preview title and get filters
    useEffect(() => {
        _getGeneralFilters();
    }, []);

    // Restore draft from localStorage only if NOT editing existing message
    useEffect(() => {
        try {
            const saved = localStorage.getItem(LS_KEY);

            if (saved && !props.editableData) {
                const data = JSON.parse(saved);

                // Restore message

                const m0 = data.message || "";
                const m1 = data.message1 || "";
                // restore all 3
                setMessage(m0);
                setMessage1(m1);
                let mesg =  buildGeneralTemplate(m0, m1);
                // combined preview ONLY
                // const combined = getCombinedMessage(m0, m1);
                // console.log('combained', data, combined);
                if (mesg) props.setPreviewContent(mesg);

                // Restore attachment related fields
                setAttachmentType(data.attachmentType || 1);
                setImageAttachments(data.imageAttachments || [{ image: "" }]);
                setVideoAttachments(data.videoAttachments || [{ video: "" }]);
                setDocAttachments(data.docAttachments || null);
                if (data.attachmentType === 1 && data.imageAttachments[0]?.image !== "") {
                    let image_array = data.imageAttachments.map((item) => {
                        return item.image
                    })
                    props.setPreviewImage(image_array);
                }
                if (data.attachmentType === 2 && data.videoAttachments[0]?.video !== "") {
                    let image_array = data.videoAttachments.map((item) => {
                        return item.video
                    })
                    props.setPreviewImage(image_array);
                }
                if (data.attachmentType === 3 && data.docAttachments) {
                    props.setPreviewImage([data.docAttachments]);
                }

                props.updateMediaType(data.attachmentType);
                // Restore CSV / URL
                setUserUrl(data.userUrl || "");
                setCsvName(data.csvName || "");

                // Restore targeting (we'll remap segment/signup/rebalance after filters load)
                setType(data.type || 1);
                // For these we set initial placeholders — real mapping happens below after generalFilters are loaded
                // store the raw values in the state so the UI shows something if SelectBox supports it
                if (data.segment) setSelectedSegment(data.segment);
                if (data.signup) setSelectedSignUpStatus(data.signup);
                if (data.rebalance) setSelectedRebalanceStatus(data.rebalance);
                setSelectedRepeatDay(data.repeat_day || null);

                // Restore scheduling
                setSendLater(data.send_later || false);
                setStartDate(data.start_date || null);
                setEndDate(data.end_date || null);
                setAddedTime(data.time || null);
                setSelectedFrequency(data.frequency || null);
                setSelectedWeekDay(data.week_day || null);

                if (data.month_day) {
                    setSelectedRepeatedDate(data.month_day);
                    setRepeatedDate({
                        label: _formatSip(data.month_day),
                        value: data.month_day
                    });
                }
                setIsOneTime(data.is_one_time);
                setNotificationUsers(data.users || []);
                setCustomPhones(Array.isArray(data.custom_phones) && data.custom_phones.length > 0 ? data.custom_phones : [""]);
                setWebinarUrlSuffix(cleanWebinarSuffix(data.webinar_url || ""));
                setWebinarContents(Array.isArray(data.webinar_contents) && data.webinar_contents.length === WEBINAR_CONTENT_COUNT ? data.webinar_contents : Array(WEBINAR_CONTENT_COUNT).fill(""));
                setStoredData({ ...STORED_DATA_WHATSAPP, ...data });
            }
        } catch (e) {
            console.warn("Failed to restore draft", e);
        }
    }, [props.editableData]);

    // After generalFilters load (or change), remap stored segment/signup/rebalance to actual option objects
    useEffect(() => {
        if (props.editableData) return; // ignore when editing an existing message

        try {
            const savedStr = localStorage.getItem(LS_KEY);
            if (!savedStr || !generalFilters || Object.keys(generalFilters).length === 0) return;
            const saved = JSON.parse(savedStr);

            // Helper: accepts either stored object {value,label} or primitive value
            const resolveOption = (list, stored) => {
                if (!list || !stored) return null;
                const storedValue = typeof stored === "object" && stored.value !== undefined ? stored.value : stored;
                return list.find(i => Number(i.value) === Number(storedValue)) || null;
            };

            const seg = resolveOption(generalFilters.segment_type, saved.segment);
            if (seg) setSelectedSegment(seg);

            const su = resolveOption(generalFilters.signup_staus, saved.signup);
            if (su) setSelectedSignUpStatus(su);

            const rb = resolveOption(generalFilters.rebalance_status, saved.rebalance);
            if (rb) setSelectedRebalanceStatus(rb);
        } catch (e) {
            // ignore
        }
    }, [generalFilters, props.editableData]);

    useEffect(() => {
        if (!startDate || !isOneTime) return;

        const now = moment();
        const isToday = moment(startDate, "DD-MM-YYYY").isSame(moment(), "day");
        const cutoffTime = moment("07:00:00PM", "hh:mm:ssA");

        if (isToday && now.isSameOrAfter(cutoffTime)) {
            setError("No time available for today");
        } else {
            setError("");
        }
    }, [startDate, isOneTime]);

    // If editableData changes (edit flow), populate fields from API data (ignore localStorage)
    useEffect(() => {
        if (props.editableData !== null) {
            const data = props.editableData;
            // Support both shapes: contents.whatsapp_data / message_detail.whatsapp_data / top-level whatsapp_data
            const whatsappData = data?.contents?.whatsapp_data ?? data?.message_detail?.whatsapp_data ?? data?.whatsapp_data;
            const customersList = Array.isArray(data?.customers_list)
                ? data.customers_list
                : (Array.isArray(data?.message_detail?.customers_list) ? data.message_detail.customers_list : []);

            const c0 = whatsappData?.content || "";
            const c1 = whatsappData?.content_one || "";

            setMessage(c0);
            setMessage1(c1);

            const combinedMsg = getCombinedMessage(c0, c1);
            props.setPreviewContent(combinedMsg);

            if (whatsappData?.images && Array.isArray(whatsappData.images) && whatsappData.images.length > 0) {
                setImageAttachments(whatsappData.images || [{ image: "" }]);
                setAttachmentType(1);
                let image_array = whatsappData.images?.map((item) => item.image) || [];
                props.setPreviewImage(image_array);
                props.updateMediaType(1);
            } else {
                setImageAttachments([{ image: "" }]);
            }

            if (whatsappData?.videos && Array.isArray(whatsappData.videos) && whatsappData.videos.length > 0) {
                setVideoAttachments(whatsappData.videos || [{ video: "" }]);
                setAttachmentType(2);
                let image_array = whatsappData.videos?.map((item) => item.video) || [];
                props.setPreviewImage(image_array);
                props.updateMediaType(2);
            }

            if (whatsappData?.doc != null) {
                setDocAttachments(whatsappData.doc);
                setAttachmentType(3);
                props.setPreviewImage([whatsappData.doc]);
                props.updateMediaType(3);
            }

            // webinar_invite: restore template selection + url + contents so the
            // webinar UI/preview shows when editing or re-sending a webinar message.
            const webinarOption = generalFilters?.wa_templates?.find(t => isWebinarTemplate(t));
            if (webinarOption && isWebinarTemplate(whatsappData?.template_type_variable ?? whatsappData?.template_name ?? whatsappData?.template)) {
                setSelectedTemplateType(webinarOption);
                setWebinarUrlSuffix(cleanWebinarSuffix(getWebinarUrlFromData(whatsappData)));
                setWebinarContents(getWebinarContentsFromData(whatsappData));
            }

            if (data?.message_detail?.csv_url !== null) {
                let file_name = data?.message_detail?.csv_url.split('/');
                setUserUrl(data?.message_detail?.csv_url);
                setCsvName(file_name[file_name.length - 1]);
            }

            const isType4 = data?.message_detail?.type === 4;
            const hasCustomersList = customersList.length > 0;
            const hasAnyPhone = hasCustomersList && customersList.some(c => (c && (c.mobile || c.phone || c.customer_phone)));
            if (isType4 || hasAnyPhone) {
                setType(4);
                const toPhoneFromCustomer = (c) => {
                    const v = c && (c.mobile || c.phone || c.customer_phone);
                    return v ? String(v).trim() : "";
                };
                const toPhoneFromCustom = (item) => {
                    const cc = item && (item.country_code || item.countryCode) ? String(item.country_code || item.countryCode).trim() : "";
                    const pn = item && (item.phone_number || item.phoneNumber) ? String(item.phone_number || item.phoneNumber).trim() : "";
                    const code = cc ? (cc.startsWith("+") ? cc : "+" + cc) : "";
                    return (code && pn) ? code + pn : "";
                };
                const fromCustomers = hasCustomersList ? customersList.map(toPhoneFromCustomer).filter(Boolean) : [];
                const fromCustomValues = Array.isArray(data?.message_detail?.custom_values) && data.message_detail.custom_values.length > 0
                    ? data.message_detail.custom_values.map(toPhoneFromCustom).filter(Boolean) : [];
                const phoneList = fromCustomers.length > 0 ? fromCustomers : fromCustomValues;
                setCustomPhones(phoneList.length > 0 ? phoneList : [""]);
            } else {
                setType(data?.message_detail?.type || 1);
            }
            if (data?.message_detail?.type === 3) {
                setSelectedSegment({ value: data?.message_detail?.segment_type, label: data?.message_detail?.segment_type_variable })
            }
            if (data?.message_detail?.segment_type === 5) {
                setSelectedRebalanceStatus({ value: data?.message_detail?.segment_type_option, label: data?.message_detail?.segment_type_option_variable })
            }
            if (data?.message_detail?.segment_type === 1) {
                setSelectedSignUpStatus({ value: data?.message_detail?.segment_type_option, label: data?.message_detail?.segment_type_option_variable });
            }

            if (data?.message_detail?.segment_days) {
                setSelectedRepeatDay(data?.message_detail?.segment_days);
            }

            if (data?.scheduled_date !== undefined && data?.scheduled_date !== null && data?.scheduled_date !== "") {
                setSendLater(true);
                if (data?.message_detail?.start_date) {
                    setStartDate(moment(data?.message_detail?.start_date).format("DD-MM-YYYY"));
                }
                if (data?.message_detail?.end_date) {
                    setEndDate(moment(data?.message_detail?.end_date).format("DD-MM-YYYY"));
                }
                if (data?.message_detail?.time) {
                    let rawTime = data?.message_detail?.time;
                    let cleaned = rawTime?.replace(/\s/g, '');
                    let time = TIME_SLOT.find(item => item.value === cleaned)

                    setAddedTime(time);
                }
                if (data?.message_detail?.frequency) {
                    setSelectedFrequency({ value: data?.message_detail?.frequency, label: data?.message_detail?.frequency_var });
                }
                if (data?.message_detail?.frequency === 1) {
                    let day = generalFilters?.repeat_day?.find(item => item.value === data?.message_detail?.repeat_day);
                    setSelectedWeekDay(day)
                } else {
                    if (data?.message_detail?.repeat_date) {
                        setSelectedRepeatedDate(data?.message_detail?.repeat_date);
                        setRepeatedDate({
                            label: _formatSip(data?.message_detail?.repeat_date),
                            value: data?.message_detail?.repeat_date
                        })
                    }
                }
                setIsOneTime(data?.message_detail?.is_one_time);
            }
        }
    }, [props.editableData, generalFilters]);

    useEffect(() => {
        const shouldFetch =
            selectedSegment &&
            (
                (selectedSegment.value === 1 && selectedSignUpStatus) ||
                (selectedSegment.value === 5 && selectedRebalanceStatus)
            );
        if (shouldFetch) {
            _getNotificationUsers();
        }
    }, [selectedSegment, selectedSignUpStatus, selectedRebalanceStatus])

    useEffect(() => {

        // webinar_invite manages its own preview (see webinar effects below).
        if (webinarTemplate) return;

        let template = "";

        const isAutoTemplate =
            type === 3 &&
            (
                selectedSegment?.value === 1 ||
                selectedSegment?.value === 3 ||
                selectedSegment?.value === 4 ||
                selectedSegment?.value === 5
            );

        if (isAutoTemplate) {
            template = pickTemplate(
                selectedSegment,
                selectedSignUpStatus,
                selectedRebalanceStatus
            );
        } else {
           
            template = buildGeneralTemplate(message, message1);
        }

        setSelectedTemplate(template);
        console.log('form here', template);
        props.setPreviewContent(template);

    }, [
        type,
        selectedSegment,
        selectedSignUpStatus,
        selectedRebalanceStatus,
    ]);

    useEffect(async () => {
        if (selectedTemplate !== "") {
            const finalTemplate = await applyDynamicNumbers(selectedTemplate);
            if (finalTemplate) {
                props.setPreviewContent(finalTemplate);
            }
        }

    }, [selectedRepeatDay, selectedTemplate])

    // ---------------- webinar_invite preview ----------------
    // Tell the parent preview to render the shared WebinarPreview component
    // (header image + caption + REGISTER button) whenever webinar_invite is active.
    useEffect(() => {
        props.setWebinarPreview && props.setWebinarPreview(webinarTemplate);
    }, [webinarTemplate]);

    // Keep the webinar preview in sync as the admin fills the header image,
    // registration url and content_one..content_seven fields. Header reuses the
    // existing imageAttachments state.
    useEffect(() => {
        if (!webinarTemplate) return;
        props.setWebinarData && props.setWebinarData({
            image: imageAttachments.map(item => item.image).filter(Boolean)[0] || "",
            url: buildWebinarUrl(webinarUrlSuffix),
            contents: webinarContents,
        });
    }, [webinarTemplate, webinarUrlSuffix, webinarContents, imageAttachments]);


    // ---------------- UI Helpers ----------------

    const _showConfirmation = () => {
        const modal = new Modal(document.getElementById("pushConfirm"));
        modal.show();
    }

    const _resetForm = () => {
        setVideoAttachments([{ video: "" }]);
        setImageAttachments([{ image: "" }]);
        setDocAttachments(null);
        setMessage("");
        setMessage1("");
        props.setPreviewContent(null);
        props.updateMediaType(1);
        props.closePopUp();
        props.setPreviewImage([]);
        setUserUrl("");
        setCsvName("");
        setType(1);
        setNotificationUsers([]);
        setCustomPhones([""]);
        setSelectedSegment(null);
        setSelectedSignUpStatus(null);
        setSelectedRebalanceStatus(null);
        setSelectedRepeatDay(null);
        setIsOneTime(false);
        setSendLater(false);
        setStartDate(null);
        setEndDate(null);
        setAddedTime(null);
        setSelectedFrequency(null);
        setSelectedRepeatedDate(null);
        setRepeatedDate(null);
        setSelectedWeekDay(null);
        setIsOneTime(false);
        setOpenPopup(false);
        setNotificationUsers([]);
        setWebinarUrlSuffix("");
        setWebinarContents(Array(WEBINAR_CONTENT_COUNT).fill(""));
        props.setWebinarPreview && props.setWebinarPreview(false);
        // Clear stored draft when resetting the form
        _clearStore();
    };

    const _formatSip = (selected_date) => {
        switch (selected_date) {
            case 1: return "1st of every month";
            case 2: return "2nd of every month";
            case 3: return "3rd of every month";
            case 21: return "21st of every month";
            case 22: return "22nd of every month";
            case 23: return "23rd of every month";
            default: return selected_date + "th of every month";
        };
    };


    const pickTemplate = (segment, signup, rebalance) => {
        if (!segment) return "";

        switch (segment.value) {

            // SIGNUP STATUS
            case 1:
                if (signup?.value === 2) return WHATSAPP_TEMPLATES.signup_account_created;
                if (signup?.value === 1) return WHATSAPP_TEMPLATES.signup_incomplete;
            // return WHATSAPP_TEMPLATES.signup_incomplete;

            case 3:
                return WHATSAPP_TEMPLATES.elapsed_since_last_investment;

            case 4:
                return WHATSAPP_TEMPLATES.elapsed_since_account_created;

            case 5:
                if (rebalance) return WHATSAPP_TEMPLATES.rebalance_pending;
                return "";

            default:
                return "";
        }
    };

    const disabledDate = (current) => {
        if (!current) return false; // safety

        // compare only by day (ignore time-of-day)
        const today = moment().startOf('day');

        // parse startDate using the same format you store it in (DD-MM-YYYY)
        const _startDate = startDate ? moment(startDate, 'DD-MM-YYYY').startOf('day') : null;

        // If startDate exists → disable all dates <= startDate (includes startDate)
        if (_startDate && _startDate.isValid()) {
            return current.isSameOrBefore(_startDate, 'day');
        }

        // If no startDate → disable past dates including today
        return current.isSameOrBefore(today, 'day');
    };

    // ---------------- ADD / REMOVE ATTACHMENTS ----------------
    const addAttachment = () => {
        if (attachmentType === 1) {
            const next = [...imageAttachments, { image: "" }];
            setImageAttachments(next);
            _updateStore("imageAttachments", next);
        } else {
            const next = [...videoAttachments, { video: "" }];
            setVideoAttachments(next);
            _updateStore("videoAttachments", next);
        }
    };

    const removeAttachment = (index) => {
        if (attachmentType === 1) {
            const nextImages = imageAttachments.filter((_, i) => i !== index);
            let images = nextImages.map((item) => { return item.image });
            props.setPreviewImage(images);
            setImageAttachments(nextImages);
            _updateStore("imageAttachments", nextImages);
        } else {
            const nextImages = videoAttachments.filter((_, i) => i !== index);
            let videos = nextImages.map((item) => { return item.video });
            props.setPreviewImage(videos);
            setVideoAttachments(nextImages);
            _updateStore("videoAttachments", nextImages);
        }

    };

    // ---------------- UPLOAD FILES ----------------

    const _uploadWhatsAppFile = (temp, index, type) => {
        const allowedDocTypes = [
            "text/csv",                                              // csv
            "application/pdf",                                       // pdf
            "application/vnd.ms-excel",                               // xls
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // xlsx
        ];

        const allowedImageTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png"
        ];

        console.log('tem;', temp.type);
        if (type === 1 && !allowedImageTypes.includes(temp.type)) {
            setError("Should only allow png, jpg, jpeg images")
            return;
        };

        if (type === 2 && !temp.type.startsWith("video/")) {
            setError("Only video files are allowed");
            return;
        };

        if (type === 3 && !allowedDocTypes.includes(temp.type)) {
            setError("Only CSV, PDF, XLS, and XLSX files are allowed");
            return;
        }

        console.log('temp', temp);

        const _startUpload = () => {
            if (type < 3) {
                setUploadingIndex(index);
            } else {
                setDocAttachLoader(true);
            }

            let url = devconfig.admin + '/file/upload'

            let data = JSON.stringify({
                file: temp.name,
                is_public: true,
            })

            APIPost(url, data).then((response) => {
                if (response.status_code === 200) {
                    _uploadWhatsAppDocument(response.data, temp, index, type); // upload file in AWS s3
                } else {
                    setUploadingIndex(-1);
                    setDocAttachLoader(false);
                }
            })
        }

        // Image attachments must be exactly 1122 x 1402 px.
        if (type === 1) {
            let preview = URL.createObjectURL(temp);
            const img = new Image();
            img.onload = () => {
                URL.revokeObjectURL(preview);
                if (img.naturalWidth !== 1122 || img.naturalHeight !== 1402) {
                    setError("Please upload an image with dimensions 1122 × 1402 px.");
                    return;
                }
                _startUpload();
            };
            img.onerror = () => {
                URL.revokeObjectURL(preview);
                setError("Unable to read the image file");
            };
            img.src = preview;
            return;
        }

        _startUpload();
    }

    const _getNotificationUsers = () => {
        setNotificationListLoader(true);
        const url = devconfig.admin + '/notification/get-users';
        let payload = JSON.stringify({
            segment_type: selectedSegment?.value,
            segment_type_option: selectedSegment?.value === 1 ? selectedSignUpStatus?.value : selectedSegment?.value === 5 ? selectedRebalanceStatus?.value : null,
            segment_days: selectedSegment?.value !== 1 && selectedSegment.value !== 5 ? Number(selectedRepeatDay) : null,
        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setNotificationUsers(response.data);
                _updateStore("users", response.data);
            } else {
                setNotificationUsers([]);
                _updateStore("users", []);
            }
            setNotificationListLoader(false);
        })
    }

    // ---- Upload to s3
    const _uploadWhatsAppDocument = async (data, file, index, type) => {
        var formdata = new FormData();
        formdata.append("key", data.upload_info.fields.key);
        formdata.append("x-amz-algorithm", data.upload_info.fields['x-amz-algorithm']);
        formdata.append("x-amz-credential", data.upload_info.fields['x-amz-credential']);
        formdata.append("x-amz-date", data.upload_info.fields['x-amz-date']);
        formdata.append("policy", data.upload_info.fields['policy']);
        formdata.append("x-amz-signature", data.upload_info.fields['x-amz-signature']);
        formdata.append("file", file, file.name);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        fetch(data.upload_info.url, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (type === 1) {
                    let content = [...imageAttachments];
                    content[index].image = data.view_info;
                    let image_array = content.map((item) => {
                        return item.image

                    })
                    setImageAttachments(content);
                    setUploadingIndex(-1);
                    props.setPreviewImage(image_array);
                    _updateStore("imageAttachments", content);
                } else if (type === 2) {
                    let videos = [...videoAttachments];
                    videos[index].video = data.view_info;
                    let video_array = videos.map((item) => {
                        return item.video

                    })
                    setVideoAttachments(videos);
                    setUploadingIndex(-1);
                    props.setPreviewImage(video_array);
                    _updateStore("videoAttachments", videos);
                } else {
                    setDocAttachLoader(false);
                    setDocAttachments(data.view_info);
                    props.setPreviewImage([data.view_info]);
                    _updateStore("docAttachments", data.view_info);
                }

            })
            .catch(error => {
                setUploadingIndex(-1);
                setDocAttachLoader(false);
            });
    }

    const _uploadFile = (temp) => {
        setCsvLoader(true);
        let url = devconfig.admin + '/file/upload'

        let data = JSON.stringify({
            file: temp.name,
            is_public: true,
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setCsvLoader(true);
                _uploadDocument(response.data, temp); // upload file in AWS s3
            } else {
                setError(response.message);
                setCsvLoader(false);
            }
        })
    }

    const _uploadDocument = async (data, file) => {
        setCsvLoader(true);
        var formdata = new FormData();
        formdata.append("key", data.upload_info.fields.key);
        formdata.append("x-amz-algorithm", data.upload_info.fields['x-amz-algorithm']);
        formdata.append("x-amz-credential", data.upload_info.fields['x-amz-credential']);
        formdata.append("x-amz-date", data.upload_info.fields['x-amz-date']);
        formdata.append("policy", data.upload_info.fields['policy']);
        formdata.append("x-amz-signature", data.upload_info.fields['x-amz-signature']);
        formdata.append("file", file, file.name);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        fetch(data.upload_info.url, requestOptions)
            .then(response => response.text())
            .then(result => {
                setCsvLoader(false);
                setUserUrl(data.view_info);
                setCsvName(file.name);
                _updateStore(null, { userUrl: data.view_info, csvName: file.name });
            })
            .catch(error => {
                setCsvLoader(false);
            });
    }

    // ---- Get API filters
    const _getGeneralFilters = () => {
        const url = devconfig.admin + '/notification/filter-data';
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                const transformedData = {};

                Object.keys(response.data).forEach((key) => {
                    const item = response.data[key];

                    // Case 1: If value is an array
                    if (Array.isArray(item)) {
                        transformedData[key] = item.map((obj) => ({
                            value: obj.id,
                            label: obj.label
                        }));
                    }

                    // Case 2: If value is an object (repeat_day, repeat_frequency)
                    else if (typeof item === "object" && item !== null) {
                        transformedData[key] = Object.keys(item).map((id) => ({
                            value: Number(id),
                            label: item[id]
                        }));
                    }

                    // Case 3: Anything else pass as it is
                    else {
                        transformedData[key] = item;
                    }
                    if (transformedData?.wa_templates?.length) {
                        console.log('transformedData.length', transformedData.length);
                        setSelectedTemplateType(transformedData.wa_templates[0]);
                    }
                });
                setGeneralFilters(transformedData)

            }
        })
    }

    const _removeEmptyItems = (arr) => {
        return arr.filter(obj => {
            const value = Object.values(obj)[0]; // first property value
            return value !== "" && value !== null && value !== undefined;
        });
    };



    /*----- send global notification api ---*/
    const _sendGlobalNotification = () => {

        const cleanImages = _removeEmptyItems(imageAttachments);
        const cleanVideos = _removeEmptyItems(videoAttachments);

        const sanitizeMessage = (msg = "") =>
            msg
                .replace(/\r?\n+/g, " ")   // replace new lines with space
                .replace(/\s{2,}/g, " ")   // remove extra spaces
                .trim();

        const sanitizedMessage = sanitizeMessage(message);

        setLoader(true);
        let api_url = props.sendAgain ? devconfig.admin + '/notification/v2/send-global' : props.editableData !== null ? devconfig.admin + '/notification/edit-scheduled-notification' : devconfig.admin + '/notification/v2/send-global'
        let schedule_data = sendLater ? {
            is_one_time: isOneTime,
            start_date: startDate,
            end_date: endDate,
            frequency: selectedFrequency?.value,
            repeat_day: selectedWeekDay?.value,
            repeat_date: repeatedDate?.value,
            time: addedTime?.value
        } : null;
        const customValues = type === 4
            ? customPhones
                .filter(p => (p || "").trim() !== "")
                .map(p => {
                    const parsed = parsePhoneNumber((p || "").trim());
                    if (!parsed || !parsed.nationalNumber) return null;
                    return { country_code: "+" + parsed.countryCallingCode, phone_number: parsed.nationalNumber };
                })
                .filter(Boolean)
            : null;

        // Existing whatsapp_data generation (General Template, template_type 1) —
        // kept exactly as before. The send-global API/audience/upload flows are reused.
        let whatsappPayload = {
            content: message && sanitizeMessage(message) || "",
            content_one: message1 && sanitizeMessage(message1) || "",
            images: attachmentType === 1 ? cleanImages.length === 0 ? null : cleanImages : null,
            videos: attachmentType === 2 ? cleanVideos.length === 0 ? null : cleanVideos : null,
            doc: attachmentType === 3 ? docAttachments : null,
            template_type: selectedTemplateType?.value,
        };

        // Extension for Webinar Template (template_type 2): same endpoint, dedicated
        // whatsapp_data shape (header image + registration url + content_one..seven).
        // content / videos / doc are not used; body_1 (name) is set by the backend.
        if (webinarTemplate) {
            whatsappPayload = {
                template_type: selectedTemplateType?.value,
                images: cleanImages.length === 0 ? null : cleanImages,
                url: buildWebinarUrl(webinarUrlSuffix),
                content_one: webinarContents[0] || "",
                content_two: webinarContents[1] || "",
                content_three: webinarContents[2] || "",
                content_four: webinarContents[3] || "",
                content_five: webinarContents[4] || "",
                content_six: webinarContents[5] || "",
                content_seven: webinarContents[6] || "",
            };
        }

        let data = JSON.stringify({
            channel: 2,
            schedule_id: props.editableData !== null ? props.editableData.id : null,
            type: type,
            csv_url: type === 4 ? null : userUrl,
            segment_type: type === 4 ? null : selectedSegment?.value,
            segment_type_option: type === 4 ? null : (selectedSignUpStatus?.value || selectedRebalanceStatus?.value),
            segment_days: type === 4 ? null : selectedRepeatDay,
            ...(type === 4 && customValues && customValues.length > 0 ? { custom_values: customValues } : {}),
            notification_data: null,
            schedule_message: schedule_data,
            whatsapp_data: whatsappPayload,
            email_data: null
        });

        APIPost(api_url, data).then((response) => {
            if (response.status_code === 200) {
                if (props.editableData !== null) {
                    setSuccess("Whatsapp message has been updated");
                    props.updateSuccess(3);
                    // When editing and saving, clear stored draft as it's not relevant
                    _clearStore();
                } else {

                    const recipientCount = type === 4 ? (customValues?.length ?? 0) : (notificationUsers?.length ?? 0);
                    const recipientLabel = type === 4 ? "custom recipient(s)" : "users";
                    if (sendLater) {
                        setSuccess(`This message will be sent to ${type === 1 ? "All users" : `the selected ${recipientCount ? recipientCount + " " : ""}${recipientLabel}`}. An intimation mail will send to the admin once it finishes sending the message to the selected user.`);
                    }
                    else {
                        setSuccess(`This message will be sent to ${type === 1 ? "All users" : `the selected ${recipientCount ? recipientCount + " " : ""}${recipientLabel}`}. An intimation mail will send to the admin once it finishes sending the message to the selected user.`);
                    }
                    // Keep fields + draft populated so the admin can send a test to themselves
                    // first and then re-send the same content to clients without re-entering it.
                    // _resetForm();
                    // _clearStore();
                }
                setLoader(false);
            } else {
                setError(response.message);
                setLoader(false);
            }
        });
    }

    async function getFileDetails(url) {
        // Extract file name
        const cleanUrl = url.split("?")[0];
        const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);

        // Extract extension
        const extension = cleanUrl.split(".").pop().toLowerCase();

        // Type mappings
        const imageExt = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
        const videoExt = ["mp4", "mov", "webm", "mkv"];
        const audioExt = ["mp3", "wav", "ogg"];
        const pdfExt = ["pdf"];
        const docExt = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];

        // 1 → image
        if (imageExt.includes(extension)) return { type: 1, fileName };

        // 2 → video
        if (videoExt.includes(extension)) return { type: 2, fileName };

        // 3 → audio
        if (audioExt.includes(extension)) return { type: 3, fileName };

        // 4 → pdf
        if (pdfExt.includes(extension)) return { type: 4, fileName };

        // 5 → docs
        if (docExt.includes(extension)) return { type: 5, fileName };

        // If extension missing → try HEAD request
        try {
            const response = await fetch(url, { method: "HEAD" });
            const contentType = response.headers.get("content-type");
            if (!contentType) return { type: 0, fileName };

            if (contentType.startsWith("image/")) return { type: 1, fileName };
            if (contentType.startsWith("video/")) return { type: 2, fileName };
            if (contentType.startsWith("audio/")) return { type: 3, fileName };
            if (contentType === "application/pdf") return { type: 4, fileName };
            if (contentType.includes("csv") || contentType === "text/csv" || contentType === "binary/octet-stream") return { type: 5, fileName };

            return { type: 0, fileName }; // unknown
        } catch (error) {
            return { type: 0, fileName }; // unknown
        }
    }

    const FileRenderer = ({ url }) => {
        const cleanUrl = url.split("?")[0];
        const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
        return <a className='e-csv-file' href={url} target="_blank" rel="noreferrer">{fileName}</a>;
    };

    const _getAvailableTime = (isOneTime) => {
        if (!isOneTime && !startDate) return TIME_SLOT;

        const now = moment();
        const isToday =
            startDate &&
            moment(startDate, "DD-MM-YYYY").isSame(moment(), "day");

        const cutoffTime = moment("07:00:00PM", "hh:mm:ssA");

        if (isToday) {
            if (now.isSameOrAfter(cutoffTime)) {
                return []; // ❌ no state update here
            }

            return TIME_SLOT.filter((slot) =>
                moment(slot.value, "hh:mm:ssA").isAfter(now)
            );
        }

        return TIME_SLOT;
    };

    const getCombinedMessage = (m1, m2, m3) => {
        return [m1, m2, m3]
            .filter(x => x && x.trim() !== "")
            .join("<br/>");
    };



    // ---------------- UI ----------------
    return (
        <div className="row px-2">

            {/* Target Audience */}
            <div className="col-12">
                <label className="d-block mb-2 pb-0">Target audience</label>
                <div className="d-flex align-items-center flex-wrap" >
                    <Radio id="all" value={1} label="All" checked={type === 1} valueClick={() => {
                        setType(1); setNotificationUsers([]); setCustomPhones([""]);
                        if (selectedTemplate !== "") { setSelectedTemplate(""); props.setPreviewContent(""); }
                        _updateStore(null, { type: 1, users: [], custom_phones: [""] });
                    }} />
                    <Radio id="upload" value={2} label="Upload segment" checked={type === 2} valueClick={() => {
                        setType(2); setNotificationUsers([]); setCustomPhones([""]);
                        if (selectedTemplate !== "") { setSelectedTemplate(""); props.setPreviewContent(""); }
                        _updateStore(null, { type: 2, users: [], custom_phones: [""] });
                    }} />
                    <Radio id="select" value={3} label="Select segment" checked={type === 3} valueClick={() => {
                        setType(3); setNotificationUsers([]); setCustomPhones([""]);
                        if (selectedTemplate !== "") { setSelectedTemplate(""); props.setPreviewContent(""); }
                        _updateStore(null, { type: 3, users: [], custom_phones: [""] });
                    }} />
                    <Radio id="custom_value" value={4} label="Custom value" checked={type === 4} valueClick={() => {
                        setType(4); setNotificationUsers([]);
                        setCustomPhones(customPhones.length ? customPhones : [""]);
                        if (selectedTemplate !== "") { setSelectedTemplate(""); props.setPreviewContent(""); }
                        _updateStore(null, { type: 4, users: [], custom_phones: customPhones.length ? customPhones : [""] });
                    }} />
                </div>
            </div>

            {type === 4 && (
                <div className="col-12 mt-2 mb-3">
                    <div className="d-flex flex-wrap align-items-flex-start gap-2">
                        {customPhones.map((phone, index) => {
                            const canDelete = customPhones.length > 1;
                            return (
                                <div key={index} className="d-flex align-items-center gap-1" style={{ flex: "0 0 calc(50% - 4px)", minWidth: "calc(50% - 4px)", maxWidth: "100%" }}>
                                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                        <PhoneInput
                                            value={phone}
                                            valueChange={(val) => {
                                                const next = [...customPhones];
                                                next[index] = val || "";
                                                setCustomPhones(next);
                                                _updateStore('custom_phones', next);
                                            }}
                                            className="e-notification-form-element"
                                        />
                                    </div>
                                    {canDelete && (
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 text-danger text-decoration-none d-flex align-items-center justify-content-center"
                                            style={{ flexShrink: 0 }}
                                            onClick={() => {
                                                const next = customPhones.length > 1 ? customPhones.filter((_, i) => i !== index) : [""];
                                                setCustomPhones(next);
                                                _updateStore('custom_phones', next);
                                            }}
                                            title="Remove phone"
                                        >
                                            <img src={Delete} alt="Remove" width={18} height={18} />
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                        <button
                            type="button"
                            className="btn btn-link p-0 text-primary text-decoration-none"
                            disabled={
                                customPhones.some(p => (p || "").trim() === "") ||
                                customPhones.some(p => {
                                    const v = (p || "").trim();
                                    if (v === "") return false;
                                    const parsed = parsePhoneNumber(v);
                                    return !parsed || !parsed.nationalNumber || parsed.nationalNumber.length < 8;
                                })
                            }
                            onClick={() => {
                                const allFilled = customPhones.every(p => (p || "").trim() !== "");
                                const allValid = customPhones.every(p => {
                                    const v = (p || "").trim();
                                    if (v === "") return false;
                                    const parsed = parsePhoneNumber(v);
                                    return parsed && parsed.nationalNumber && parsed.nationalNumber.length >= 8;
                                });
                                if (!allFilled || !allValid) return;
                                const next = [...customPhones, ""];
                                setCustomPhones(next);
                                _updateStore('custom_phones', next);
                            }}
                        >
                            + Add new phone
                        </button>
                    </div>
                </div>
            )}

            {
                (() => {
                    // auto template active segments
                    const autoTemplateActive =
                        type === 3 && (
                            // signup based
                            selectedSegment?.value === 1 ||
                            // elapsed since last investment
                            selectedSegment?.value === 3 ||
                            // elapsed since account created
                            selectedSegment?.value === 4 ||
                            // rebalance
                            selectedSegment?.value === 5
                        );

                    // show editor only when NOT auto template
                    if (autoTemplateActive === true) return null;
                    return (
                        <>
                            {
                                type !== 3 && (
                                    <div className="col-lg-12 pe-0 mb-3">
                                        <div className='d-flex justify-content-between'>
                                            <label>Choose template type</label>
                                        </div>
                                        <SelectBox
                                            isSearchable={false}
                                            options={generalFilters?.wa_templates}
                                            placeholder="Select template"
                                            value={selectedTemplateType}
                                            selectchange={(selected_value) => {
                                                const wasWebinar = webinarTemplate;
                                                const willWebinar = isWebinarTemplate(selected_value);
                                                // TEMP DEBUG: remove before commit
                                                console.log('[webinar] selectedTemplate:', selected_value,
                                                    '| value(template_type):', selected_value?.value,
                                                    '| label:', selected_value?.label,
                                                    '| isWebinar:', willWebinar);
                                                setSelectedTemplateType(selected_value);
                                                if (willWebinar) {
                                                    // webinar uses the image header; force image attachment mode.
                                                    setAttachmentType(1);
                                                    props.updateMediaType(1);
                                                } else if (wasWebinar) {
                                                    // Leaving webinar -> restore the general content preview.
                                                    props.setWebinarPreview && props.setWebinarPreview(false);
                                                    props.setPreviewContent(getCombinedMessage(message, message1));
                                                }
                                            }} />
                                    </div>
                                )
                            }
                        </>
                    )
                })()

            }


            {
                type === 3 ?

                    <div className='col-12 mt-2 mb-3'>
                        <SelectBox
                            value={selectedSegment}
                            placeholder="Choose segment"
                            options={generalFilters?.segment_type}
                            selectchange={(temp) => {
                                setSelectedSegment(temp);
                                setNotificationUsers([]);
                                // store full object like Notification
                                _updateStore({ 'date': null, 'segment': temp });
                                setSelectedRepeatDay(null);
                                _updateStore("users", []);
                            }} />
                    </div>

                    : type === 2 ?
                        <div className='col-lg-12'>
                            <label>Upload csv url</label>
                            <div className="e-uploader mb-4 position-relative" onClick={() => { $('#e-csv-upload').click() }}>
                                {
                                    csvName ?
                                        <img src={Delete} alt="delete"
                                            width={"32px"} className='position-absolute e-delete-image' style={{ right: "15px", top: "10px", cursor: "pointer" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCsvName("");
                                                setUserUrl("");
                                                _updateStore(null, { csvName: "", userUrl: "" });
                                            }} />
                                        :
                                        null
                                }
                                <div className='text-center'>
                                    <p className='text-center mb-2'>
                                        {
                                            csvName ? csvName : "Upload csv file"
                                        }
                                    </p>
                                </div>
                                <FileUpload
                                    accept={".csv"}
                                    className="d-none"
                                    id="e-csv-upload"
                                    key="e-upload-image"
                                    upload={(temp) => {
                                        _uploadFile(temp)
                                    }} />
                            </div>
                        </div>
                        :
                        null
            }

            {
                selectedSegment && type === 3 && (
                    <>
                        {
                            selectedSegment?.value === 1 ?
                                <div className='col=12 mt-2 mb-3'>
                                    <label>Select signup status</label>
                                    <SelectBox
                                        value={selectedSignUpStatus}
                                        placeholder="Choose signup status"
                                        options={generalFilters?.signup_staus}
                                        selectchange={(temp) => {
                                            setSelectedSignUpStatus(temp)
                                            _updateStore("signup", temp);
                                        }} />
                                </div>
                                : selectedSegment?.value === 5 ?
                                    <div className='col=12 mt-2 mb-3'>
                                        <label>Select rebalance status</label>
                                        <SelectBox
                                            value={selectedRebalanceStatus}
                                            placeholder="Choose rebalance status"
                                            options={generalFilters?.rebalance_status}
                                            selectchange={(temp) => {
                                                setSelectedRebalanceStatus(temp)
                                                _updateStore({ 'date': null, 'rebalance': temp });
                                                setSelectedRepeatDay(null);
                                            }} />
                                    </div>
                                    : <div className='col=12 mt-2 mb-3'>
                                        <label>Enter days</label>
                                        <div className='position-relative'>
                                            <Input
                                                placeholder="Enter elapsed days"
                                                type="number"
                                                value={selectedRepeatDay}
                                                className="e-notification-form-element"
                                                valueChange={(temp) => {
                                                    _updateStore('date', temp);
                                                    setSelectedRepeatDay(temp);
                                                }}
                                            />
                                            {
                                                selectedRepeatDay && (
                                                    <div className='e-not-search-btn' onClick={_getNotificationUsers}>
                                                        <img src={require('../../assets/images/notification/right-arrow.png').default} width="25px" />
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                        }
                    </>
                )
            }

            {/* Message Editor */}
            {
                (() => {
                    // auto template active segments
                    const autoTemplateActive =
                        type === 3 && (
                            // signup based
                            selectedSegment?.value === 1 ||
                            // elapsed since last investment
                            selectedSegment?.value === 3 ||
                            // elapsed since account created
                            selectedSegment?.value === 4 ||
                            // rebalance
                            selectedSegment?.value === 5
                        );

                    // show editor only when NOT auto template
                    if (autoTemplateActive === true) return null;

                    // webinar_invite: replace free-form content + attachment UI
                    // with header image upload + registration url + content_one..seven.
                    if (webinarTemplate) {
                        const headerImage = imageAttachments?.[0]?.image || "";
                        return (
                            <>
                                {/* header_1 image */}
                                <div className="col-lg-12 pe-0 mb-3">
                                    <label>Select File for header_1</label>
                                    {headerImage !== "" ? (
                                        <div className="e-preview position-relative mb-3">
                                            <img
                                                src={Delete}
                                                alt="delete"
                                                width="32"
                                                className="position-absolute e-delete-image"
                                                style={{ right: 16, cursor: "pointer" }}
                                                onClick={() => {
                                                    const arr = [{ image: "" }];
                                                    setImageAttachments(arr);
                                                    props.setPreviewImage([]);
                                                    _updateStore("imageAttachments", arr);
                                                }}
                                            />
                                            {uploadingIndex === 0 ? (
                                                <img src={LoaderImg} height="40px" />
                                            ) : (
                                                <FallbackImage src={headerImage} alt="header preview" width="100%" height="100%" style={{ objectFit: "contain" }} />
                                            )}
                                            <FileUpload
                                                accept="image/png, image/jpeg, image/jpg"
                                                className="d-none"
                                                id="e-upload-webinar-header"
                                                upload={(file) => _uploadWhatsAppFile(file, 0, 1)}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className="e-uploader mb-4"
                                            onClick={() => { $('#e-upload-webinar-header').click(); }}
                                        >
                                            <div className="text-center">
                                                {uploadingIndex === 0 ? (
                                                    <img src={LoaderImg} height="40px" />
                                                ) : (
                                                    <p className="text-center mb-2">Select File for header_1</p>
                                                )}
                                            </div>
                                            <FileUpload
                                                accept="image/png, image/jpeg, image/jpg"
                                                className="d-none"
                                                id="e-upload-webinar-header"
                                                upload={(file) => _uploadWhatsAppFile(file, 0, 1)}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* Registration URL — plain input; the fixed base url
                                    (WEBINAR_URL_PREFIX) is prepended internally when building
                                    the final url for preview + payload. */}
                                <div className="col-lg-12 pe-0 mb-3">
                                    <label>Registration URL *</label>
                                    <Input
                                        placeholder="e.g. webinar/register"
                                        value={webinarUrlSuffix}
                                        className="e-notification-form-element"
                                        valueChange={(temp) => {
                                            // auto-extract suffix if the full forms.gle url is pasted
                                            const suffix = cleanWebinarSuffix(temp);
                                            setWebinarUrlSuffix(suffix);
                                            if (!props.editableData) {
                                                _updateStore("webinar_url", suffix);
                                            }
                                        }}
                                    />
                                    {/* Helper: base url is added automatically; admin enters only the path. */}
                                    <p className="mb-0 mt-1" style={{ color: '#8a8a8a', fontSize: '12px' }}>
                                        Base URL <b>{WEBINAR_URL_PREFIX}</b> is added automatically — enter only the path (e.g. <b>webinar/register</b>).
                                    </p>
                                    {
                                        webinarUrlSuffix && !isValidWebinarSuffix(webinarUrlSuffix) ?
                                            <p className="mb-0 mt-1" style={{ color: '#dc3545', fontSize: '12px' }}>
                                                Enter only the path (e.g. webinar/register), not a full URL
                                            </p>
                                            : null
                                    }
                                </div>

                                {/* content_one .. content_seven */}
                                {webinarContents.map((value, index) => (
                                    <div className="col-lg-12 pe-0 mb-3" key={`webinar-content-${index}`}>
                                        <label>{`${WEBINAR_CONTENT_KEYS[index]} *`}</label>
                                        <Input
                                            placeholder={`Enter ${WEBINAR_CONTENT_KEYS[index]} value`}
                                            value={value}
                                            className="e-notification-form-element"
                                            valueChange={(temp) => {
                                                const next = [...webinarContents];
                                                next[index] = temp;
                                                setWebinarContents(next);
                                                if (!props.editableData) {
                                                    _updateStore("webinar_contents", next);
                                                }
                                            }}
                                        />
                                    </div>
                                ))}
                            </>
                        );
                    }

                    return (
                        <>


                            <div className="col-lg-12 pe-0 mb-3">
                                <div className='d-flex justify-content-between'>
                                    <label>Content</label>

                                    <TextBtn
                                        name="Template Instructions"
                                        toggle="modal"
                                        target="#view-instructions"
                                        className="e-instruction-btn"
                                    />
                                </div>

                                <WhatsappEditor
                                    value={message}
                                    initialValue={message}
                                    onChange={(html) => {
                                        setMessage(html);
                                        const combined = getCombinedMessage(html, message1);
                                        props.setPreviewContent(combined);

                                        if (!props.editableData) {
                                            _updateStore("message", html);
                                        }
                                    }}
                                />
                            </div>

                            <div className="col-lg-12 pe-0 mb-3">
                                <div className='d-flex justify-content-between'>
                                    <label>Content 1</label>
                                </div>

                                <WhatsappEditor
                                    value={message1}
                                    initialValue={message1}
                                    onChange={(html) => {
                                        setMessage1(html);
                                        const combined = getCombinedMessage(message, html);
                                        props.setPreviewContent(combined);

                                        if (!props.editableData) {
                                            _updateStore("message1", html);
                                        }
                                    }}
                                />
                            </div>

                            <div className="col-12 d-flex align-items-center ">
                                <label className="me-3 pb-0">Attachment type</label>
                                <Radio id="image" value={1} label="Image" checked={attachmentType === 1} valueClick={() => {
                                    setAttachmentType(1);
                                    setImageAttachments([{ image: "" }]);
                                    props.updateMediaType(1);
                                    props.closePopUp();
                                    _updateStore(null, { attachmentType: 1, imageAttachments: [{ image: "" }] });
                                }} />
                                <Radio id="video" value={2} label="Video" checked={attachmentType === 2} valueClick={() => {
                                    setAttachmentType(2);
                                    props.updateMediaType(2);
                                    props.closePopUp();
                                    setVideoAttachments([{ video: "" }]);
                                    _updateStore(null, { attachmentType: 2, videoAttachments: [{ video: "" }] });
                                }} />
                                <Radio id="doc" value={3} label="Document" checked={attachmentType === 3} valueClick={() => {
                                    setAttachmentType(3);
                                    props.updateMediaType(3);
                                    props.closePopUp();
                                    setDocAttachments(null);
                                    _updateStore(null, { attachmentType: 3, docAttachments: null });
                                }} />
                            </div>

                            {
                                attachmentType === 1 ?
                                    <>
                                        {imageAttachments?.map((item, index) => (
                                            <div
                                                key={index}
                                                className={index > 0 ? "border-top pt-3" : ""}
                                            >
                                                <div className="col-lg-12 pe-0">
                                                    <div className="d-flex w-100 justify-content-between">
                                                        <label>Upload Image/Pdf (Image size: 1122 × 1402 px)</label>
                                                        {index > 0 && (
                                                            <p
                                                                className="e-remove-attachment"
                                                                onClick={() => removeAttachment(index)}
                                                            >
                                                                Remove attachment
                                                            </p>
                                                        )}
                                                    </div>

                                                    {item.image !== "" ? (
                                                        <div className="e-preview position-relative mb-3">
                                                            <img
                                                                src={Delete}
                                                                alt="delete"
                                                                width="32"
                                                                className="position-absolute e-delete-image"
                                                                style={{ right: 16, cursor: "pointer" }}
                                                                onClick={() => {
                                                                    let arr = [...imageAttachments];
                                                                    arr[index].image = "";
                                                                    let image_array = arr
                                                                        .map(item => item.image)
                                                                        .filter(item => item !== "");
                                                                    props.setPreviewImage(image_array);
                                                                    setImageAttachments(arr);
                                                                    _updateStore("imageAttachments", arr);
                                                                }}
                                                            />

                                                            {uploadingIndex === index ? (
                                                                <img src={LoaderImg} height="40px" />
                                                            ) : (
                                                                <img src={item.image} width="100%" height="100%" style={{ objectFit: "contain" }} />
                                                            )}

                                                            <FileUpload
                                                                accept="image/png, image/jpeg, image/jpg"
                                                                className="d-none"
                                                                id={`e-upload-wht-content-${index}`}
                                                                upload={(file) => _uploadWhatsAppFile(file, index, attachmentType)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="e-uploader mb-4"
                                                            onClick={() => { $(`#e-upload-wht-content-${index}`).click(); }}
                                                        >
                                                            <div className="text-center">
                                                                {uploadingIndex === index ? (
                                                                    <img src={LoaderImg} height="40px" />
                                                                ) : (
                                                                    <p className="text-center mb-2">
                                                                        Upload image
                                                                    </p>
                                                                )}
                                                            </div>

                                                            <FileUpload
                                                                accept="image/png, image/jpeg, image/jpg"
                                                                className="d-none"
                                                                id={`e-upload-wht-content-${index}`}
                                                                upload={(file) => _uploadWhatsAppFile(file, index, attachmentType)}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                    : attachmentType === 2 ?
                                        <>
                                            {videoAttachments?.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className={index > 0 ? "border-top pt-3" : ""}
                                                >
                                                    <div className="col-lg-12 pe-0">
                                                        <div className="d-flex w-100 justify-content-between">
                                                            <label>Upload video</label>
                                                            {index > 0 && (
                                                                <p
                                                                    className="e-remove-attachment"
                                                                    onClick={() => removeAttachment(index)}
                                                                >
                                                                    Remove attachment
                                                                </p>
                                                            )}
                                                        </div>

                                                        {item.video !== "" ? (
                                                            <div className="e-preview position-relative mb-3">
                                                                <img
                                                                    src={Delete}
                                                                    alt="delete"
                                                                    width="32"
                                                                    className="position-absolute e-delete-image"
                                                                    style={{ right: 16, cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        let arr = [...videoAttachments];
                                                                        arr[index].video = "";
                                                                        let video_array = arr
                                                                            .map(item => item.video)
                                                                            .filter(item => item !== "");

                                                                        props.setPreviewImage(video_array);
                                                                        setVideoAttachments(arr);
                                                                        _updateStore("videoAttachments", arr);
                                                                    }}
                                                                />

                                                                {uploadingIndex === index ? (
                                                                    <img src={LoaderImg} height="40px" />
                                                                ) : (
                                                                    <video src={item.video} width="100%" height="100%" loop controls={false} autoPlay={true} style={{ objectFit: "contain" }} />
                                                                )}

                                                                <FileUpload
                                                                    accept="video/*"
                                                                    className="d-none"
                                                                    id={`e-upload-wht-content-${index}`}
                                                                    upload={(file) => _uploadWhatsAppFile(file, index, attachmentType)}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="e-uploader mb-4"
                                                                onClick={() => { $(`#e-upload-wht-content-${index}`).click(); }}
                                                            >
                                                                <div className="text-center">
                                                                    {uploadingIndex === index ? (
                                                                        <img src={LoaderImg} height="40px" />
                                                                    ) : (
                                                                        <p className="text-center mb-2">
                                                                            Upload video
                                                                        </p>
                                                                    )}
                                                                </div>

                                                                <FileUpload
                                                                    accept="video/*,"
                                                                    className="d-none"
                                                                    id={`e-upload-wht-content-${index}`}
                                                                    upload={(file) => _uploadWhatsAppFile(file, index, attachmentType)}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                        :
                                        <div
                                            className={"border-top pt-3"}
                                        >
                                            <div className="col-lg-12 pe-0">
                                                <div className="d-flex w-100 justify-content-between">
                                                    <label>Upload attachment</label>
                                                </div>

                                                {docAttachments !== null ? (
                                                    <div className="e-preview position-relative mb-3">
                                                        <img
                                                            src={Delete}
                                                            alt="delete"
                                                            width="32"
                                                            className="position-absolute e-delete-image"
                                                            style={{ right: 16, cursor: "pointer" }}
                                                            onClick={() => {
                                                                setDocAttachments(null);
                                                                props.setPreviewImage([])
                                                                _updateStore("docAttachments", null);
                                                            }}
                                                        />

                                                        {docAttachLoader ? (
                                                            <img src={LoaderImg} height="40px" />
                                                        ) : (
                                                            <FileRenderer url={docAttachments} />
                                                        )}

                                                        <FileUpload
                                                            accept="application/pdf/,.csv"
                                                            className="d-none"
                                                            id={`e-upload-wht-doc`}
                                                            upload={(file) => _uploadWhatsAppFile(file, null, attachmentType)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="e-uploader mb-4"
                                                        onClick={() => { $(`#e-upload-wht-doc`).click(); }}
                                                    >
                                                        <div className="text-center">
                                                            {docAttachLoader ? (
                                                                <img src={LoaderImg} height="40px" />
                                                            ) : (
                                                                <p className="text-center mb-2">
                                                                    Upload attachment
                                                                </p>
                                                            )}
                                                        </div>

                                                        <FileUpload
                                                            accept="application/pdf/,.csv"
                                                            className="d-none"
                                                            id={`e-upload-wht-doc`}
                                                            upload={(file) => _uploadWhatsAppFile(file, null, attachmentType)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                            }

                        </>
                    );
                })()
            }




            {
                // attachmentType < 3 && (
                //     <>
                //         {
                //             attachmentType === 1 ?
                //                 <>
                //                     {imageAttachments?.length < 4 && (
                //                         <div className={imageAttachments[imageAttachments.length - 1].image !== "" ? "col-12 d-flex justify-content-between border-bottom" : "col-12 d-flex justify-content-between border-bottom e-disabled-btn "}>
                //                             <p className="e-add-attachment-btn" onClick={addAttachment}>
                //                                 <img src={require('../../assets/images/notification/link.svg').default} />
                //                                 Add new attachment
                //                             </p>
                //                             <p className="e-remark-count">You can upload up to 5 attachments</p>
                //                         </div>
                //                     )}
                //                 </>
                //                 :
                //                 <>
                //                     {videoAttachments?.length < 2 && (
                //                         <div className={videoAttachments[videoAttachments.length - 1].video !== "" ? "col-12 d-flex justify-content-between border-bottom" : "col-12 d-flex justify-content-between border-bottom e-disabled-btn "}>
                //                             <p className="e-add-attachment-btn" onClick={addAttachment}>
                //                                 <img src={require('../../assets/images/notification/link.svg').default} />
                //                                 Add new attachment
                //                             </p>
                //                             <p className="e-remark-count">You can upload up to 2 attachments</p>
                //                         </div>
                //                     )}
                //                 </>
                //         }

                //     </>
                // )

            }

            {
                sendLater === true && (
                    <div className='row pt-3 border-top'>
                        <div className='col-12 d-flex justify-content-between'>
                            <label className='me-5'>Schedule message</label>
                            <div className='d-flex align-items-center'>
                                <Toggle checked={isOneTime} onChange={(e) => {
                                    setIsOneTime(e.target.checked);
                                    _updateStore({ is_one_time: e.target.checked, frequency: null, start_date: null, end_date: null, time: null, week_day: null, month_day: null });
                                    setSelectedFrequency(null);
                                    setStartDate(null);
                                    setEndDate(null);
                                    setAddedTime(null);
                                    setSelectedWeekDay(null);
                                    setSelectedRepeatedDate(null);
                                }} />
                                <span className={`${style.e_toggle_label} ps-2 `}>One time</span>
                            </div>
                        </div>
                        {
                            isOneTime === false && (
                                <div className='col-6 pb-4'>
                                    <label className='mb-1'>Select frequency</label>
                                    <SelectBox
                                        isSearchable={false}
                                        options={generalFilters?.repeat_frequency}
                                        placeholder="Select frequency"
                                        value={selectedFrequency}
                                        selectchange={(selected_value) => {
                                            setSelectedFrequency(selected_value);
                                            _updateStore('frequency', selected_value);
                                        }} />
                                </div>
                            )
                        }


                        <div className='col-6 pb-4'>
                            <label className='mb-1'>Start date</label>
                            <Datepicker
                                value={startDate}
                                disabledDate={(current) => current.isBefore(moment().startOf("day"))}
                                onChange={(value) => {
                                    setStartDate(value);
                                    _updateStore('start_date', value);
                                }}
                            />

                        </div>
                        {
                            isOneTime === false && (
                                <div className='col-6 pb-4'>
                                    <label className='mb-1'>End date</label>
                                    <Datepicker
                                        value={endDate}
                                        disabledDate={disabledDate}
                                        onChange={(value) => {
                                            setEndDate(value);
                                            _updateStore('end_date', value);
                                        }}
                                    />

                                </div>
                            )
                        }

                        <div className='col-6 pb-4'>
                            <label className='mb-1'>Add time</label>
                            <SelectBox
                                isSearchable={false}
                                options={_getAvailableTime(isOneTime)}
                                placeholder="Select time"
                                value={addedTime}
                                selectchange={(selected_value) => {
                                    setAddedTime(selected_value);
                                    _updateStore('time', selected_value);
                                }} />
                        </div>

                        {
                            selectedFrequency ?
                                <>
                                    {
                                        selectedFrequency.value === 1 ?
                                            <div className='col-6 pb-4'>
                                                <label className='mb-1'>Select week day</label>
                                                <SelectBox
                                                    isSearchable={false}
                                                    options={generalFilters?.repeat_day}
                                                    placeholder="Select week day"
                                                    value={selectedWeekDay}
                                                    selectchange={(selected_value) => {
                                                        setSelectedWeekDay(selected_value);
                                                        _updateStore('week_day', selected_value);
                                                    }} />
                                            </div>
                                            : selectedFrequency.value === 2 ?
                                                <div className="col-6 position-relative pb-4">
                                                    <label>Frequency</label>
                                                    <div className="cursor-pointer" onClick={() => setShowDropdown(true)}>
                                                        <SelectBox isDisabled
                                                            value={repeatedDate}
                                                            isSearchable={false}
                                                            placeholder="Select Day"
                                                            className=''
                                                        />
                                                    </div>
                                                    {
                                                        showDropdown ?
                                                            <div className='position-absolute e-date-dropdown p-3' ref={searchRef} >
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h6>Select date</h6>
                                                                    <button id="close-sip"
                                                                        type="button"
                                                                        className="btn-close"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() => setShowDropdown(false)} >
                                                                    </button>
                                                                </div>

                                                                <div className="d-flex flex-wrap text-center">
                                                                    {NORMALIZED_SIP_DATES.map((item, key) => (
                                                                        <div className={` d-flex align-items-center justify-content-center e-cart-date ${selectedRepeatedDate === item ? "e-active-date" : "e-cart-date color-eerie-black cursor-pointer"}`}
                                                                            key={key}
                                                                            onClick={() => {
                                                                                setSelectedRepeatedDate(item)
                                                                            }} >
                                                                            {item}
                                                                        </div>
                                                                    ))}

                                                                </div>



                                                                <div className='mt-3 col-12 mx-auto'>
                                                                    <PrimaryBtn name="Confirm date"
                                                                        className="padding-10px-tb w-100 color"
                                                                        handleClick={() => {
                                                                            setRepeatedDate({
                                                                                label: _formatSip(selectedRepeatedDate),
                                                                                value: selectedRepeatedDate
                                                                            });
                                                                            _updateStore('month_day', selectedRepeatedDate);
                                                                            setShowDropdown(false)
                                                                        }} />
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                :
                                                null

                                    }
                                </>
                                : null
                        }

                    </div>
                )
            }
            <div className='' style={{minHeight: "60px"}}>
            {
                notificationListLoader ?
                    <div className='col-12'>
                        <img src={LoaderImg} alt="" height="40px" width="100%" style={{ objectFit: "contain", marginTop: "20px" }} />
                    </div>
                    :
                    notificationUsers?.length ?
                        <div className='col-12 e-view-users-table'>
                            <div className='d-flex align-items-center cursor-pointer' style={{ width: 'max-content' }}
                                onClick={() => setOpenUsersList(!openUsersList)}>
                                <TextBtn className='mt-1 me-1'
                                    name={`Eligible users(${notificationUsers.length})`}
                                    handleClick={() => { }} />
                                <div className='e-user-arrow-down'
                                    data-direction={openUsersList}></div>
                            </div>
                            <>
                                {
                                    openUsersList === true ?
                                        <DataTable
                                            pagination={false}
                                            columns={TABLE_COLUMN}
                                            data={notificationUsers}
                                            paginationServer={true}
                                            selectableRows={false}
                                        />
                                        : null
                                }
                            </>

                        </div>
                        : null
            }
            </div>

            {/* Buttons */}
            <div className="col-lg-12 d-flex justify-content-start text-left mb-3 mt-4">
                {
                    props.editableData && props.sendAgain === false ? (
                        <>
                            {(() => {

                                const autoTemplateActive =
                                    type === 3 &&
                                    (
                                        selectedSegment?.value === 1 ||
                                        selectedSegment?.value === 3 ||
                                        selectedSegment?.value === 4 ||
                                        selectedSegment?.value === 5
                                    );

                                const hasAnyMessage =
                                    (message && message.length > 1) ||
                                    (message1 && message1.length > 1);

                                /* -------- Segment validation -------- */
                                const segmentValid =
                                    type === 3
                                        ? (
                                            selectedSegment?.value === 1
                                                ? selectedSignUpStatus
                                                : selectedSegment?.value === 5
                                                    ? selectedRebalanceStatus
                                                    : selectedRepeatDay
                                        )
                                        : true;

                                /* -------- Schedule validation -------- */
                                const scheduleValid = !sendLater
                                    ? true
                                    : isOneTime
                                        ? Boolean(startDate && addedTime)
                                        : Boolean(
                                            startDate &&
                                            endDate &&
                                            addedTime &&
                                            selectedFrequency &&
                                            (
                                                selectedFrequency?.value === 1
                                                    ? selectedWeekDay
                                                    : selectedRepeatedDate
                                            )
                                        );

                                const customPhonesValid = type === 4 ? (() => {
                                    const hasEmpty = customPhones.some(p => (p || "").trim() === "");
                                    const filled = customPhones.filter(p => (p || "").trim() !== "");
                                    const allValid = filled.every(p => {
                                        const parsed = parsePhoneNumber((p || "").trim());
                                        return parsed && parsed.nationalNumber && parsed.nationalNumber.length >= 8;
                                    });
                                    return !hasEmpty && filled.length > 0 && allValid;
                                })() : true;
                                const isValid =
                                    (
                                        webinarTemplate
                                            ? webinarReady       // webinar requires header + all 8 body vars
                                            : autoTemplateActive // allow even if messages empty
                                            || hasAnyMessage     // manual requires at least one
                                    ) &&
                                    (
                                        type === 2
                                            ? userUrl
                                            : type === 3
                                                ? selectedSegment
                                                : type === 4
                                                    ? customPhonesValid
                                                    : true
                                    ) &&
                                    Boolean(segmentValid) &&
                                    scheduleValid;

                                return isValid ? (
                                    <PrimaryBtn
                                        name="Save"
                                        className={
                                            loader
                                                ? "e-notification-form-btn e-btn-loader e-disabled"
                                                : "e-notification-form-btn"
                                        }
                                        handleClick={_showConfirmation}
                                    />
                                ) : (
                                    <PrimaryBtn name="Save" className="e-disabled" />
                                );
                            })()}
                        </>
                    ) : (
                        <>
                            {(() => {

                                const autoTemplateActive =
                                    type === 3 &&
                                    (
                                        selectedSegment?.value === 1 ||
                                        selectedSegment?.value === 3 ||
                                        selectedSegment?.value === 4 ||
                                        selectedSegment?.value === 5
                                    );

                                const hasAnyMessage =
                                    (message && message.length > 1) ||
                                    (message1 && message1.length > 1);

                                /* -------- Segment validation -------- */
                                const segmentValid =
                                    type === 3
                                        ? (
                                            selectedSegment?.value === 1
                                                ? selectedSignUpStatus
                                                : selectedSegment?.value === 5
                                                    ? selectedRebalanceStatus
                                                    : selectedRepeatDay
                                        )
                                        : true;

                                const customPhonesValidSend = type === 4 ? (() => {
                                    const hasEmpty = customPhones.some(p => (p || "").trim() === "");
                                    const filled = customPhones.filter(p => (p || "").trim() !== "");
                                    const allValid = filled.every(p => {
                                        const parsed = parsePhoneNumber((p || "").trim());
                                        return parsed && parsed.nationalNumber && parsed.nationalNumber.length >= 8;
                                    });
                                    return !hasEmpty && filled.length > 0 && allValid;
                                })() : true;
                                /* -------- Send now validation -------- */
                                const sendNowValid =
                                    (
                                        webinarTemplate
                                            ? webinarReady       // webinar requires header + all 8 body vars
                                            : autoTemplateActive // allow
                                            || hasAnyMessage     // manual requires one
                                    ) &&
                                    (
                                        type === 2
                                            ? userUrl
                                            : type === 3
                                                ? selectedSegment
                                                : type === 4
                                                    ? customPhonesValidSend
                                                    : true
                                    ) &&
                                    Boolean(segmentValid) &&
                                    sendLater === false;

                                return sendNowValid ? (
                                    <PrimaryBtn
                                        name="Send now"
                                        className={
                                            loader
                                                ? "e-notification-form-btn e-btn-loader e-disabled"
                                                : "e-notification-form-btn"
                                        }
                                        handleClick={_showConfirmation}
                                    />
                                ) : (
                                    <>
                                        {
                                            sendLater ? (
                                                <SecondaryBtn
                                                    name="Cancel scheduling"
                                                    handleClick={() => setSendLater(false)}
                                                />
                                            ) : (
                                                <PrimaryBtn name="Send now" className="e-disabled" />
                                            )
                                        }
                                    </>
                                );
                            })()}

                            {
                                sendLater === false ? (
                                    <SecondaryBtn
                                        name="Send later"
                                        className="ms-3"
                                        handleClick={() => {
                                            setSendLater(true);
                                            _updateStore("send_later", true);
                                        }}
                                    />
                                ) : (
                                    <>
                                        {(() => {
                                            const scheduleValid = isOneTime
                                                ? Boolean(startDate && addedTime)
                                                : Boolean(
                                                    startDate &&
                                                    endDate &&
                                                    addedTime &&
                                                    selectedFrequency &&
                                                    (
                                                        selectedFrequency?.value === 1
                                                            ? selectedWeekDay
                                                            : selectedRepeatedDate
                                                    )
                                                );
                                            const audienceValid = type === 4 ? (() => {
                                                const hasEmpty = customPhones.some(p => (p || "").trim() === "");
                                                const filled = customPhones.filter(p => (p || "").trim() !== "");
                                                const allValid = filled.every(p => {
                                                    const parsed = parsePhoneNumber((p || "").trim());
                                                    return parsed && parsed.nationalNumber && parsed.nationalNumber.length >= 8;
                                                });
                                                return !hasEmpty && filled.length > 0 && allValid;
                                            })() : true;

                                            // webinar requires header + all 8 body vars before scheduling.
                                            const contentValid = webinarTemplate ? webinarReady : true;

                                            return scheduleValid && audienceValid && contentValid ? (
                                                <PrimaryBtn
                                                    name="Schedule now"
                                                    className={
                                                        loader
                                                            ? "e-notification-form-btn e-btn-loader e-disabled ms-3"
                                                            : "e-notification-form-btn ms-3"
                                                    }
                                                    handleClick={_showConfirmation}
                                                />
                                            ) : (
                                                <PrimaryBtn
                                                    name="Schedule now"
                                                    className="ms-3 e-disabled"
                                                />
                                            );
                                        })()}
                                    </>
                                )
                            }
                        </>
                    )
                }
            </div>



            {/*--------- error toast --------*/}
            {
                error !== null ?
                    <Toast
                        data={error}
                        type="error"
                        id="1"
                        onClose={() => {
                            setError(null);
                        }}
                    />
                    :
                    null
            }

            {/*--------- success toast --------*/}
            {
                success !== null ?
                    <Toast
                        data={success}
                        type="success"
                        id="2"
                        onClose={() => {
                            setSuccess(null);
                        }}
                    />
                    :
                    null
            }
            <NotificationConfirm
                type={type}
                notificationType={3}
                sendLater={sendLater}
                Confirm={() => {
                    _sendGlobalNotification();
                }} />

            <ViewTemplateInstructions />
        </div >
    );
};

export default WhatsAppMessage;
